var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card',[_c('div',{staticClass:"text-center p-4"},[_c('PowerBiIframe',{staticClass:"container-iframe",attrs:{"title":"Reporte PESV","user":_vm.userLoggedIn,"reportData":_vm.aboutSeccionResultados}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }